import { Link, useNavigate } from "react-router-dom"
import { Text, VImage } from "../../style/base.style"
import { useDictionary } from "../../contexts/dictionary"
import { useFormHandling } from "../../hooks/formUtils"
import { downloadFile, RequestConfigs } from "../../api"
import { useEffect, useState } from "react"
import { useContactType } from "../../contexts/ContactContext"
import { TableColumn, TableComponent } from "../common/TableComponent"
import { useDeviceType } from "../../contexts/DeviceContext"
import { ActionButton, ButtonStyle } from "../buttons/ActionButton"



interface ActionButtonProps {
  row: any
}



const ClickableId = ({row}:ActionButtonProps) => {
  const navigate = useNavigate()
  const nav = () => {
      navigate(`/dashboard/invoices/${row.id}`)
  }

  return <ActionButton style={ButtonStyle.light} label={row.Invoice_Number.toString()} onClick={()=>{nav()}}/>
}

export const Invoices = () => {
    const {translate} = useDictionary()
    const {serverRes,handleClick} = useFormHandling({requestType:RequestConfigs.getInvoices})
    const [invoices,setInvoices] = useState<Invoice[]>([])
     const {contact} = useContactType()

     const columns:TableColumn[] = [
      {
          id: 'Invoice_Number',
          label: translate('invoice_id'),
     
      },
     
      {
          id: 'Subject',
          label: translate('description')
      },
      {
          id: 'Grand_Total',
          label: translate('amount'),
          renderCell: (row:Invoice) => {return <>₪{row.Grand_Total.toFixed(2)}</>}    
      },
      
      {
          id: 'Created_Time',
          label: translate('issued_on'),
          type: 'date'
      },
      {
        id:'Download',
        label: translate('download'),
        renderCell: (row:Invoice) => {
          return <ActionButton style={ButtonStyle.light} label={translate('download')} onClick={() => {downloadFile('/contact/invoices/'+row.payments0__File,row.Invoice_Number+".pdf")}}/>
        }
      },
     
     
    ]


    useEffect(() => {
        handleClick()
    }, [])
    useEffect(() => {
        if(serverRes?.invoices){
            setInvoices(serverRes.invoices)
        }

    }, [serverRes])

    console.log('invoices',invoices)
    const {isMobile} = useDeviceType()





    const downloadForm= useFormHandling({requestType:RequestConfigs.downloadInvoice})

    const downloadInvoice = async (id:string) => {
        const res = await downloadForm.handleClick(null,{id:id})
        console.log("download res",res)
    }

    return (
        <div className="dashboard-card-body" style={{width:'100%'}}>
        <div className="contact-detail-table">
          {/* Tab Menu */}

          {/* /Tab Menu */}
          {/* Tab Content */}
          <TableComponent idColumn="Invoice_Number" columns={columns} data={invoices} columnToShow={isMobile?3:columns.length}/>
       
          {/* Tab Content */}
        </div>
      </div>
    )
}